// extracted by css-extract-rspack-plugin
module.exports =  {"transactionId":"CancelUserTransactionModal__transactionId___htMGB"};